import { createColumnQueryClient } from '@column/api';

export const queryClient = createColumnQueryClient();
